export default __webpack_public_path__ + "static/media/GridContent.097b6e85.less";